module.exports = {
  portal: {
    title: "Portal: tek dijital calisma ortami",
    subtitle: "Kurumsal erisim yonetimi, belge akisi, muhasebe, laboratuvar, ulasim, SKUD ve entegrasyonlar icin ortak platform.",
    summaryTitle: "Portal neyi cozer",
    summaryText: "Portal daginik is sureclerini /app arayuzunde birlestirir. Kullanici sadece yetkili uygulamalara erisir, tum islemler denetlenebilir kayitlara yazilir.",
    summaryPoints: [
      "AD ve FBA hesaplari tek erisim modelinde",
      "Tutarlı yetki kurallari ile moduler apps/*",
      "Entegrasyonlar: 1C, banka API'leri, Kontur.Focus, DaData, SKUD, FortMonitor",
      "Merkezi loglama ve analiz icin AI asistani"
    ],
    stats: [
      { value: "35+", label: "uygulama" },
      { value: "10+", label: "entegrasyon" },
      { value: "24/7", label: "log izleme" }
    ],
    integrationsTitle: "Entegrasyon haritasi",
    integrationsSubtitle: "Dairesel grafik platformdaki entegrasyon alanlarini gosterir",
    integrationShares: [
      { name: "Active Directory / LDAP", value: 18, color: "#3b82f6" },
      { name: "1C + Banka API", value: 22, color: "#10b981" },
      { name: "SKUD / Mikrotik", value: 16, color: "#f59e0b" },
      { name: "Kontur.Focus / DaData", value: 14, color: "#ef4444" },
      { name: "FortMonitor / Haritalar", value: 12, color: "#a855f7" },
      { name: "OpenAI / WOPI / Mesajlasma", value: 18, color: "#06b6d4" }
    ],
    appsTitle: "Uygulama goruntuleyici",
    appsSubtitle: "Alan secerek ilgili uygulamalari inceleyin",
    openAppLabel: "Modulu ac",
    appFilters: [
      { code: "all", label: "Tum" },
      { code: "document", label: "Belge akisi" },
      { code: "accounting", label: "Muhasebe" },
      { code: "laboratory", label: "Laboratuvar" },
      { code: "control", label: "SKUD ve izleme" },
      { code: "platform", label: "Platform" }
    ],
    appCatalog: [
      {
        title: "contragents",
        area: "Belge akisi",
        href: "/app/pw/contragents",
        categories: ["all", "document"],
        description: "Karsi taraf kartlari, veri zenginlestirme ve risk kontrolu.",
        features: ["DaData ve Kontur.Focus", "Degisim gecmisi", "Sorumlu bildirimleri"]
      },
      {
        title: "waybills",
        area: "Ulasim",
        href: "/app/pw/waybills",
        categories: ["all", "document", "control"],
        description: "Sefer, rota ve yakit kaydi ile yazdirilabilir yol formlari.",
        features: ["Filo baglantisi", "Sefer analitigi", "PDF formlar"]
      },
      {
        title: "banksoperations",
        area: "Muhasebe",
        href: "/app/accounting/banksoperations",
        categories: ["all", "accounting"],
        description: "Banka hareketlerinin aktarimi ve odeme kontrolu.",
        features: ["API otomatik aktarim", "Tutar kontrolu", "Sozlesme eslestirme"]
      },
      {
        title: "lab_equipment",
        area: "Laboratuvar",
        href: "/app/laboratory/lab_equipment",
        categories: ["all", "laboratory"],
        description: "Laboratuvar ekipman kayitlari ve teknik envanter yonetimi.",
        features: ["Gruplar ve pasaportlar", "NDT baglantisi", "Bakim gunlugu"]
      },
      {
        title: "chatgpt",
        area: "Platform",
        href: "/app/system/chatgpt",
        categories: ["all", "platform"],
        description: "Dosya, log ve operasyon verileri icin AI asistani.",
        features: ["Diyalog gecmisi", "Log analizi", "Ek dosya isleme"]
      },
      {
        title: "syslogserver",
        area: "SKUD ve izleme",
        href: "/app/system/syslogserver",
        categories: ["all", "control", "platform"],
        description: "Kullanici ve sistem olaylari icin merkezi denetim.",
        features: ["Olay filtreleri", "Rapor disa aktarma", "Islem zaman cizelgesi"]
      }
    ],
    cardsTitle: "Teknik mimari",
    cardsSubtitle: "Guvenilirlik ve olceklenebilirlik icin temel bilesenler",
    cards: [
      { riIcon: "RiReactjsLine", title: "Client SPA", text: "React + Redux + Ant Design, /app uzerinde masaustu ve widget yapisi." },
      { riIcon: "RiNodejsLine", title: "Node.js Backend", text: "Express, socket.io, API gecitleri ve SSR sayfalari." },
      { riIcon: "RiDatabase2Line", title: "Data Layer", text: "Sistem ve is verisi alanlari ayrilmis MongoDB yapisi." },
      { riIcon: "RiSettings4Line", title: "Service Scheduler", text: "Senkronizasyon, temizlik ve entegrasyon icin arka plan gorevleri." }
    ],
    workflowTitle: "Canliya gecis akisi",
    workflowSubtitle: "Mevcut is surecini bozmadan adim adim gecis",
    workflow: [
      { num: "01", riIcon: "RiSearchLine", title: "Altyapi analizi", text: "BT ortami, veri kaynaklari ve kullanici rollerini degerlendiririz." },
      { num: "02", riIcon: "RiServerLine", title: "Kurulum", text: "Altyapiyi ve temel platform servislerini devreye aliriz." },
      { num: "03", riIcon: "RiArrowRightUpLine", title: "Entegrasyon", text: "1C, AD, bankalar, SKUD ve dis API'leri asamali baglariz." },
      { num: "04", riIcon: "RiCheckboxCircleLine", title: "Operasyon", text: "Ekip egitimi, proseslerin sabitlenmesi ve destek baslangici." }
    ],
    listTitle: "Is sonucu",
    listSubtitle: "Uygulama sonrasinda kazanilan temel deger",
    listItems: [
      "Dagitik araclar yerine tek dijital calisma duzeni",
      "Manuel is yukunde ve veri tekrarinda azalma",
      "Kullanici hareketlerinde seffaflik ve guvenlik izi",
      "Yonetim icin analitige hizli erisim"
    ],
    ctaTitle: "Demo talep edin",
    ctaText: "Portal'i sizin gercek senaryolarinizla gosterelim ve uygulama plani cikaralim.",
    primaryHref: "/pages/contact",
    primaryLabel: "Iletisim",
    secondaryHref: "/pages/services",
    secondaryLabel: "Servisleri incele",
    presentationBtn: "Sunumu görüntüle",
    presentationHref: "/pages/presentation-app",
    forWhomTitle: "Portal kimin için",
    forWhomSubtitle: "Karmaşık çok bölümlü yapıya sahip endüstriyel işletmeler için tasarlandı",
    forWhomItems: [
      { riIcon: "RiBuildingLine", title: "Endüstriyel şirketler", text: "Çok bölümlü yapıya ve karmaşık iç süreçlere sahip işletmeler." },
      { riIcon: "RiGroupLine", title: "Kurumsal IT ekipleri", text: "Bulut bağımlılığı olmadan yönetilebilir platform isteyen ekipler." },
      { riIcon: "RiUserStarLine", title: "Yöneticiler ve analistler", text: "Güncel verilere ve karar alma araçlarına ihtiyaç duyan liderler." },
      { riIcon: "RiAccountBoxLine", title: "Son kullanıcılar", text: "Tek arayüz üzerinden yalnızca izinli uygulamalara erişen personel." }
    ]
  }
};
